import DataGrid from './DataGrid';
import DataGridFilters from './DataGridFilters';
import DataGridFilterSearch from './DataGridFilterSearch';
import DataGridFilterSearchForm from './DataGridFilterSearchForm';
import DataGridPagination from './DataGridPagination';
DataGrid.Filters = DataGridFilters;
DataGrid.FilterSearch = DataGridFilterSearch;
DataGrid.FilterSearchForm = DataGridFilterSearchForm;
DataGrid.Pagination = DataGridPagination;
export default DataGrid;